import React from "react";

import Navigation from "../Navigation";
import MtuUsage from "./charts/MtuUsage";
import DestinationUsage from "./charts/DestinationUsage";

export const MtuReports = () => {
  return (
    <Navigation>
      <div className="flex flex-col items-center justify-center h-full w-full p-5 space-y-5">
        <MtuUsage />
        <DestinationUsage />
      </div>
    </Navigation>
  );
};
